// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jWzjd6m01x_fAZcQsCCb {
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    116.81deg,
    rgba(3, 120, 209, 0.25) -7.65%,
    rgba(255, 255, 255, 0.25) 71.29%
  )
}

.u8JJ2i_u4T7q4TWKrO8X {
  display: flex;
  height: 500px;
  width: 100%;
  max-width: 531px;
  flex-direction: column;
  justify-content: center;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 2rem;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  background: linear-gradient(
    110.41deg,
    rgba(255, 255, 255, 0.67) -1.18%,
    rgba(255, 255, 255, 0.62) 98.72%
  )
}

.u8JJ2i_u4T7q4TWKrO8X .ant-input-outlined {
  border-radius: 5px !important
}

.E9GGjAgQNfr0GwIdHPJC {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center
}

.y2swsqpYG0TBOIlywpqg {
  height: 3rem;
  width: 289px
}

.LEulFv0jN3cowkteIhZx {
  text-align: center;
  font-family: Noto Sans;
  font-size: 35px;
  font-weight: 700
}

.rxozRmVHvTXvN6eDS23_ {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}
.rGRv5mljys0Fj2iq2zn2 {
  display: flex;
  gap: 1rem
}
.o1xeDx8I_ZvAWrCCyoBz {
  margin-bottom: 17px;
  width: 40%;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.iHOlnQbXhmytFUJk656q {
  margin-right: 0.25rem;
  height: 17px;
  width: 14px
}
.X3AfzeqNkHlOnqlp5nla {
  margin-bottom: 17px;
  width: 60%;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.VR_G5FgDkib78O1kwLh2 {
  margin-right: 0.25rem;
  height: 14px;
  width: 14px
}
.pcu6YzpN0QBjpK99qj5b {
  margin-bottom: 17px;
  flex: 1 1 0%;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.ACDVr26iXerC8o6iY0Sw {
  margin-right: 0.25rem;
  height: 16px;
  width: 16px
}
.ojcEKCI1qRV_clqXvt5g {
  margin-bottom: 0px !important;
  margin-top: 1.5rem
}

.Pr424sTc6CZscJMiU635 {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  font-size: 16px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.Pr424sTc6CZscJMiU635:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

.q4SeyIccH2YiwxloG8jA {
  margin-top: 1rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResetPassword/ResetPassword.module.css"],"names":[],"mappings":"AACE;EAAA,aAAoD;EAApD,iBAAoD;EAApD,mBAAoD;EAApD,uBAAoD;EACpD;;;;;AADoD;;AASpD;EAAA,aAAuG;EAAvG,aAAuG;EAAvG,WAAuG;EAAvG,gBAAuG;EAAvG,sBAAuG;EAAvG,uBAAuG;EAAvG,kBAAuG;EAAvG,kBAAuG;EAAvG,4DAAuG;EAAvG,aAAuG;EAAvG,+EAAuG;EAAvG,mGAAuG;EAAvG,uGAAuG;EACvG;;;;;AADuG;;AASvG;EAAA;AAAqB;;AAIrB;EAAA,qBAA+B;EAA/B,aAA+B;EAA/B;AAA+B;;AAI/B;EAAA,YAAqB;EAArB;AAAqB;;AAIrB;EAAA,kBAAmD;EAAnD,sBAAmD;EAAnD,eAAmD;EAAnD;AAAmD;;AAInD;EAAA,qBAAmF;EAAnF,aAAmF;EAAnF,uBAAmF;EAAnF,mBAAmF;EAAnF,sBAAmF;EAAnF,sBAAmF;EAAnF,eAAmF;EAAnF,gBAAmF;EAAnF,oBAAmF;EAAnF;AAAmF;AAGnF;EAAA,aAAiB;EAAjB;AAAiB;AAGjB;EAAA,mBAAyE;EAAzE,UAAyE;EAAzE,sBAAyE;EAAzE,eAAyE;EAAzE,gBAAyE;EAAzE,oBAAyE;EAAzE;AAAyE;AAGzE;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;AAG7B;EAAA,mBAAyE;EAAzE,UAAyE;EAAzE,sBAAyE;EAAzE,eAAyE;EAAzE,gBAAyE;EAAzE,oBAAyE;EAAzE;AAAyE;AAGzE;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;AAG7B;EAAA,mBAAwE;EAAxE,YAAwE;EAAxE,sBAAwE;EAAxE,eAAwE;EAAxE,gBAAwE;EAAxE,oBAAwE;EAAxE;AAAwE;AAGxE;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;AAG7B;EAAA,6BAAiB;EAAjB;AAAiB;;AAIjB;EAAA,YAA8G;EAA9G,WAA8G;EAA9G,kBAA8G;EAA9G,6BAA8G;EAA9G,qEAA8G;EAA9G,eAA8G;EAA9G,gBAA8G;EAA9G,oBAA8G;EAA9G;AAA8G;;AAA9G;EAAA,+BAA8G;EAA9G;AAA8G;;AAI9G;EAAA,gBAA2H;EAA3H,aAA2H;EAA3H,eAA2H;EAA3H,mBAA2H;EAA3H,uBAA2H;EAA3H,YAA2H;EAA3H,kBAA2H;EAA3H,sBAA2H;EAA3H,eAA2H;EAA3H,gBAA2H;EAA3H,oBAA2H;EAA3H;AAA2H","sourcesContent":[".gradientBg {\n  @apply flex items-center justify-center min-h-screen;\n  background: linear-gradient(\n    116.81deg,\n    rgba(3, 120, 209, 0.25) -7.65%,\n    rgba(255, 255, 255, 0.25) 71.29%\n  );\n}\n\n.formContainer {\n  @apply bg-white rounded-[5px] shadow-lg p-8 w-full max-w-[531px] h-[500px] flex flex-col justify-center;\n  background: linear-gradient(\n    110.41deg,\n    rgba(255, 255, 255, 0.67) -1.18%,\n    rgba(255, 255, 255, 0.62) 98.72%\n  );\n}\n\n.formContainer :global(.ant-input-outlined) {\n  @apply !rounded-[5px];\n}\n\n.logo {\n  @apply flex justify-center mb-6;\n}\n\n.logoImage {\n  @apply w-[289px] h-12;\n}\n\n.loginHeading {\n  @apply text-[35px] font-bold font-inter text-center;\n}\n\n.loginSubTitle {\n  @apply font-inter text-gray-600 font-button text-body py-2 mb-6 flex justify-center;\n}\n.gridForm {\n  @apply flex gap-4;\n}\n.tenantCode {\n  @apply w-[40%] text-gray-500 font-inter font-button text-button mb-[17px];\n}\n.tenantIcon {\n  @apply w-[14px] h-[17px] mr-1;\n}\n.userId {\n  @apply w-[60%] text-gray-500 font-inter font-button text-button mb-[17px];\n}\n.userIcon {\n  @apply w-[14px] h-[14px] mr-1;\n}\n.password {\n  @apply flex-1 text-gray-500 font-inter font-button text-button mb-[17px];\n}\n.passwordIcon {\n  @apply w-[16px] h-[16px] mr-1;\n}\n.login {\n  @apply !mb-0 mt-6;\n}\n\n.submitButton {\n  @apply !bg-secondary w-full h-[50px] text-button font-dashboardMain text-white rounded-[5px] hover:!text-white;\n}\n\n.footer {\n  @apply font-bold text-primary mt-4 font-inter text-[12px] flex items-center justify-center text-center gap-1 cursor-pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gradientBg": `jWzjd6m01x_fAZcQsCCb`,
	"formContainer": `u8JJ2i_u4T7q4TWKrO8X`,
	"logo": `E9GGjAgQNfr0GwIdHPJC`,
	"logoImage": `y2swsqpYG0TBOIlywpqg`,
	"loginHeading": `LEulFv0jN3cowkteIhZx`,
	"loginSubTitle": `rxozRmVHvTXvN6eDS23_`,
	"gridForm": `rGRv5mljys0Fj2iq2zn2`,
	"tenantCode": `o1xeDx8I_ZvAWrCCyoBz`,
	"tenantIcon": `iHOlnQbXhmytFUJk656q`,
	"userId": `X3AfzeqNkHlOnqlp5nla`,
	"userIcon": `VR_G5FgDkib78O1kwLh2`,
	"password": `pcu6YzpN0QBjpK99qj5b`,
	"passwordIcon": `ACDVr26iXerC8o6iY0Sw`,
	"login": `ojcEKCI1qRV_clqXvt5g`,
	"submitButton": `Pr424sTc6CZscJMiU635`,
	"footer": `q4SeyIccH2YiwxloG8jA`
};
export default ___CSS_LOADER_EXPORT___;
